import request from '@/config/axios'
import type { PageParam } from '@/types/common'
import type { PageResult } from '@/api/lawyer'

export interface FirmCommissionRuleVO {
  id?: number
  name: string
  baseType: string
  rate: number
  lawyerId?: number
  lawyerName?: string
  enabled?: boolean
  effectiveFrom?: string
  effectiveTo?: string
  remark?: string
}

export interface FirmCommissionEntryVO {
  id?: number
  ruleId: number
  caseId: number
  lawyerId: number
  lawyerName?: string
  sourceType: string
  sourceId: number
  baseAmount: number
  rate: number
  amount: number
  status?: string
  caseTitle?: string
  firmCaseNo?: string
}

export const FirmCommissionApi = {
  createRule: (data: FirmCommissionRuleVO) =>
    request.post({ url: '/lawyer/firm/commission/rule/create', data }),
  updateRule: (data: FirmCommissionRuleVO) =>
    request.put({ url: '/lawyer/firm/commission/rule/update', data }),
  deleteRule: (id: number) =>
    request.delete({ url: '/lawyer/firm/commission/rule/delete?id=' + id }),
  pageRule: (params: PageParam & { baseType?: string; enabled?: boolean }) =>
    request.get<PageResult<FirmCommissionRuleVO>>({
      url: '/lawyer/firm/commission/rule/page',
      params
    }),
  pageEntry: (params: PageParam & { caseId?: number; lawyerId?: number; status?: string }) =>
    request.get<PageResult<FirmCommissionEntryVO>>({
      url: '/lawyer/firm/commission/entry/page',
      params
    }),
  generate: (data: { ruleId: number; sourceType: string; sourceId: number }) =>
    request.post({ url: '/lawyer/firm/commission/entry/generate', data }),
  voidEntry: (id: number) =>
    request.put({ url: '/lawyer/firm/commission/entry/void?id=' + id })
}
